import React, { PureComponent } from 'react';
import { Card, Button, Row, Col, Container, Badge } from 'react-bootstrap';
import { FaFileUpload, FaFileExcel, FaDownload, FaInfoCircle, FaListOl, FaExchangeAlt, FaFileAlt } from 'react-icons/fa';
import Spinner from '../subcomponent/spinner';
import extractInfo from '../../middleware/extractInfo';
import { CSVLink } from "react-csv";

export default class cargaTerceros extends PureComponent {
    constructor(props) {
        super(props)
        this.uploadTxtFile = this.uploadTxtFile.bind(this);
        this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.state = {
            csvData: [],
            txtData: [],
            loadingCsv: false,
            loadingText: false
        }
    }
    uploadTxtFile(event) {
        this.setState({ loadingCsv: true });
        const callback = this.terminadoCsv;
        let tmp = [];
        const cabecera = extractInfo.processCabeceraTerceros();
        tmp.push(cabecera);
        const fileReader = new FileReader();
        const file = event.target.files[0];
        fileReader.readAsText(file);

        fileReader.onloadend = function () {
            const lines = this.result.split('\n');

            lines.forEach((element, i) => {
                if (element.substring(6, 8) === "01" || element.substring(6, 8) === "99") {
                    const data = extractInfo.processLineTerceros(element);
                    tmp.push(data);
                }
            });
            callback(tmp);
        }
    }

    uploadCsvFile(event) {
        this.setState({ loadingText: true });
        const callback = this.terminadoText;
        const fileReader = new FileReader();
        const file = event.target.files[0];
        let tmp = "";
        fileReader.readAsText(file);

        fileReader.onloadend = function () {
            const rows = this.result.split("\n");
            let data = [];
            rows.forEach((element, i) => {
                if (i > 0) {
                    let limpieza = element.replace(/"/g, '');
                    if (limpieza.search(";") > 0) data = limpieza.split(";");
                    if (limpieza.search("\t") > 0) data = limpieza.split("\t");
                    if (Number(data[0]) === 99 || Number(data[0]) === 1) {
                        const finalData = extractInfo.processFormatCadena(data, i);
                        tmp += finalData;
                    }
                }
            });
            callback(tmp);
        }
    }

    terminadoCsv = (tmp) => {
        this.setState({ loadingCsv: false, csvData: tmp });
    }

    terminadoText = (tmp) => {
        const now = new Date();
        const year = now.getFullYear().toString();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString();
        const name = "001" + year.substr(3, 1) + month + day + ".TE9";

        const element = document.createElement("a");
        const file = new Blob([tmp], { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = name;
        document.body.appendChild(element);
        element.click();

        this.setState({ loadingText: false });
    }

    render() {
        const { csvData } = this.state;
        const { loadingText } = this.state;
        const { loadingCsv } = this.state;

        const pasos = [
            { num: 1, text: "Generar el archivo de transmisión desde el módulo M → Mantenimiento → Comercial → Transmisión de Catálogos → Terceros" },
            { num: 2, text: "Entrar a la carpeta TRM y validar la creación del archivo" },
            { num: 3, text: "Cargar el archivo generado en la opción 'Carga archivo del TRM'" },
            { num: 4, text: "Presionar el botón de 'Descargar Excel'" },
            { num: 5, text: "Editar Archivo de Excel. Nota: Si solo desea actualizar régimen y responsabilidad, debe editar la columna T y la columna U" },
            { num: 6, text: "Guardar los cambios realizados en el Excel (Guardar como CSV delimitado por coma)" },
            { num: 7, text: "Cargar archivo de Excel modificado en la opción 'Generador de archivo actualizado'" },
            { num: 8, text: "Copiar el archivo descargado desde la plataforma en la carpeta TRM" },
            { num: 9, text: "Recepcionar el archivo al sistema CGUNO M → Mantenimiento → Comercial → Recepción de Catálogos → Terceros" },
            { num: 10, text: "Seleccionar el archivo para cargar desde el CGUNO" },
        ];

        const customCsvLink = csvData.length > 0 ? (
            <CSVLink data={csvData} filename={"TERCEROS.csv"} separator={";"} className="text-decoration-none">
                <Button variant="success" size="lg" className="d-flex align-items-center gap-2">
                    <FaDownload /> Descargar Excel
                </Button>
            </CSVLink>
        ) : null;

        return (
            <Container fluid className="py-4">
                <div className="text-center mb-4">
                    <h3 className="text-primary font-weight-bold">
                        <FaExchangeAlt className="mr-2" />
                        Proceso de Actualización de Terceros en el Sistema CGUNO
                    </h3>
                    <p className="text-muted">Cargue los archivos y siga los pasos para actualizar la información de terceros</p>
                </div>

                <Row className="justify-content-center">
                    <Col lg={5} md={6} className="mb-4">
                        <Card className="shadow-sm h-100 border-0" style={{ borderRadius: '12px' }}>
                            <Card.Header className="bg-primary text-white py-3" style={{ borderRadius: '12px 12px 0 0' }}>
                                <h5 className="mb-0 d-flex align-items-center">
                                    <FaFileAlt className="mr-2" />
                                    Carga Archivo del TRM
                                </h5>
                            </Card.Header>
                            <Card.Body className="d-flex flex-column">
                                <div className="text-center my-4">
                                    <div className="upload-zone p-4 rounded-lg mb-3" style={{ backgroundColor: '#f8f9fa', border: '2px dashed #dee2e6' }}>
                                        <FaFileUpload size={40} className="text-muted mb-2" />
                                        <p className="mb-0 text-muted">Arrastre o seleccione archivo</p>
                                        <small className="text-muted">Archivos .TE*</small>
                                    </div>
                                    <label className="btn btn-outline-primary btn-lg cursor-pointer">
                                        <input
                                            type="file"
                                            name="myFile"
                                            accept=".TE?"
                                            onChange={this.uploadTxtFile}
                                            style={{ display: 'none' }}
                                        />
                                        <FaFileUpload className="mr-2" />
                                        Seleccionar Archivo
                                    </label>
                                </div>
                                <div className="text-center mt-auto">
                                    {loadingCsv && <Spinner loading={loadingCsv} />}
                                    {!loadingCsv && customCsvLink}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={5} md={6} className="mb-4">
                        <Card className="shadow-sm h-100 border-0" style={{ borderRadius: '12px' }}>
                            <Card.Header className="bg-success text-white py-3" style={{ borderRadius: '12px 12px 0 0' }}>
                                <h5 className="mb-0 d-flex align-items-center">
                                    <FaExchangeAlt className="mr-2" />
                                    Generador Plano Actualizado
                                </h5>
                            </Card.Header>
                            <Card.Body className="d-flex flex-column">
                                <div className="text-center my-4">
                                    <div className="upload-zone p-4 rounded-lg mb-3" style={{ backgroundColor: '#f8f9fa', border: '2px dashed #dee2e6' }}>
                                        <FaFileExcel size={40} className="text-muted mb-2" />
                                        <p className="mb-0 text-muted">Arrastre o seleccione archivo CSV</p>
                                        <small className="text-muted">Archivos .csv</small>
                                    </div>
                                    <label className="btn btn-outline-success btn-lg cursor-pointer">
                                        <input
                                            type="file"
                                            name="myxlsFile"
                                            accept=".csv"
                                            onChange={this.uploadCsvFile}
                                            style={{ display: 'none' }}
                                        />
                                        <FaFileUpload className="mr-2" />
                                        Seleccionar CSV
                                    </label>
                                </div>
                                <div className="text-center mt-auto">
                                    {loadingText && <Spinner loading={loadingText} />}
                                    {!loadingText && (
                                        <Badge variant="secondary" className="py-2 px-3">
                                            Listo para cargar archivo CSV
                                        </Badge>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Card className="shadow-sm mt-4 border-0" style={{ borderRadius: '12px' }}>
                    <Card.Header className="bg-info text-white py-3" style={{ borderRadius: '12px 12px 0 0' }}>
                        <h5 className="mb-0 d-flex align-items-center">
                            <FaListOl className="mr-2" />
                            Pasos para el Proceso
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                {pasos.slice(0, 5).map((paso) => (
                                    <div key={paso.num} className="d-flex align-items-start mb-3">
                                        <Badge
                                            variant="primary"
                                            className="mr-3 mt-1 p-2"
                                            style={{ width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            {paso.num}
                                        </Badge>
                                        <p className="mb-0 text-muted" style={{ lineHeight: '1.6' }}>{paso.text}</p>
                                    </div>
                                ))}
                            </Col>
                            <Col md={6}>
                                {pasos.slice(5).map((paso) => (
                                    <div key={paso.num} className="d-flex align-items-start mb-3">
                                        <Badge
                                            variant="primary"
                                            className="mr-3 mt-1 p-2"
                                            style={{ width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            {paso.num}
                                        </Badge>
                                        <p className="mb-0 text-muted" style={{ lineHeight: '1.6' }}>{paso.text}</p>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card className="shadow-sm mt-4 border-0 bg-light" style={{ borderRadius: '12px' }}>
                    <Card.Body className="d-flex align-items-center">
                        <FaInfoCircle size={24} className="text-info mr-3" />
                        <div>
                            <strong>Nota importante:</strong>
                            <p className="mb-0 text-muted">
                                Si solo desea actualizar régimen y responsabilidad, debe editar la columna T y la columna U del Excel
                            </p>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/archivos/cargaTerceros.jsx